import { Component } from '@angular/core';

import { AbstractCellComponent } from '@camelot/core';

import { PaymentExecutionStatus } from '../../../services/dto/payment-execution-status';
import { PaymentExecutionStatusComponent } from '../../payment-execution-status/payment-execution-status.component';

@Component({
  host: { 'data-cid': 'grid-payment-execution-status-cell' },
  imports: [PaymentExecutionStatusComponent],
  selector: '',
  template: `<div class="align-center" style="height: 100%">
    <cam-payment-execution-status [status]="this.status"></cam-payment-execution-status>
  </div>`,
})
export class GridPaymentExecutionStatusCellComponent extends AbstractCellComponent<any, PaymentExecutionStatus> {
  get status() {
    return this.value ?? PaymentExecutionStatus.Unknown;
  }
}
